import React from 'react';

/**
 * Resolves a slot element by id after the tree has committed, so a portal source can render
 * into a target that lives elsewhere in the layout (a sibling, or further up the tree).
 *
 * `useLayoutEffect` rather than `useEffect` so the portalled content is not a frame late.
 * Returns `null` while unresolved — and for an empty id, so callers can pass a conditional id
 * without branching on the hook.
 */
export const useSlotPortal = (id: string): HTMLElement | null => {
  const [node, setNode] = React.useState<HTMLElement | null>(null);

  React.useLayoutEffect(() => {
    setNode(id ? document.getElementById(id) : null);
  }, [id]);

  return node;
};
